import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';

interface FullPageLoaderProps {
  open: boolean;
  message?: string;
  timeout?: number; 
}

const FullPageLoader: React.FC<FullPageLoaderProps> = ({
  open = false,
  message = 'Loading...',
  timeout = 20000,
}) => {
  const [timeoutReached, setTimeoutReached] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (open) {
      setTimeoutReached(false);
      timer = setTimeout(() => {
        setTimeoutReached(true);
      }, timeout);
    }
    return () => clearTimeout(timer);
  }, [open, timeout]);

  if (!open) return null; 

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(2px)',
      }}
    >
      <CircularProgress color="primary" size={60} />
      <Typography
        variant="body1"
        style={{
          marginTop: 20,
          textAlign: 'center',
          color: '#333',
          maxWidth: '80%',
        }}
      >
        {timeoutReached
          ? 'Loading is taking longer than usual. Please check your connection and try again'
          : message}
      </Typography>
    </div>
  );
};

export default FullPageLoader;
